<template>
  <SuperAdminShell>
    <div class="super-admin-page">
      <header class="super-admin-page__header">
        <div class="super-admin-page__header-lead">
          <h3>Nova Empresa</h3>
          <small>Cadastre uma nova empresa na plataforma</small>
        </div>
        <div class="super-admin-page__header-actions">
          <button type="button" class="btnSave btnFillPreview" @click="fillPreviewData">
            Preencher tudo
          </button>
        </div>
      </header>
      <div class="super-admin-page__shell">
        <div class="super-admin-page__panel" v-if="hasReady">
            <div class="section-title">
              <div class="section-title__row">
                <h4>Informações da Empresa</h4>
                <button type="button" class="btnSave btnFillPreview btnFillSection" @click="fillCompanySection">
                  Preencher dados
                </button>
              </div>
              <p>Preencha os dados básicos da empresa</p>
              <p class="sa-field-subtle">
                Campos com <fa icon="fa-solid fa-circle-exclamation"></fa> têm regras do recebedor Pagar.me / compras Weeduc — passe o mouse para ver.
              </p>
            </div>
            <div class="row">
              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Razão Social<v-tooltip text="Obrigatório para o recebedor. Depois de criado na Pagar.me, praticamente imutável." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="tradeName"
                      placeholder="Digite a razão social"
                    />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Nome Fantasia<v-tooltip text="Obrigatório para o recebedor. Depois de criado na Pagar.me, praticamente imutável." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="name"
                      placeholder="Digite o nome fantasia"
                    />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CNPJ<v-tooltip text="Obrigatório (14 dígitos). Imutável após criar o recebedor. Outro CNPJ exige nova empresa." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="idFiscal"
                      placeholder="Digite o CNPJ"
                      v-mask="'##.###.###/####-##'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>E-mail<v-tooltip text="Obrigatório. Depois de criado o recebedor, praticamente imutável na Pagar.me." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="email"
                      placeholder="Digite o e-mail"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Telefone<v-tooltip text="Obrigatório (DDD + mínimo 10 dígitos). Depois de criado o recebedor, praticamente imutável." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="phone"
                      placeholder="Digite o telefone"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                </div>
             </div>

             <!-- Seção: Endereço -->
             <div class="col-form-inner col-12 col-md-12 col-lg-12">
               <div class="section-title">
                 <div class="section-title__row">
                   <h4>Endereço</h4>
                   <button type="button" class="btnSave btnFillPreview btnFillSection" @click="fillAddressSection">
                     Preencher dados
                   </button>
                 </div>
                 <p>Informe o endereço completo da empresa</p>
               </div>
             </div>
             <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>CEP<v-tooltip text="Obrigatório (8 dígitos) para criar o recebedor Pagar.me." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00000-000"
                      v-model="postcode"
                      v-mask="'#####-###'"
                      @input="getCep"
                    />
                  </div>
                </div>
              </div>

               
              <!-- <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="col-form-inner col-12 col-md-12 col-lg-12 cep">
                  <div class="form-group actions">
                    <button class="btn">
                      Pesquisar
                    </button>
                  </div>
                </div>
              </div>
 -->

              <div class="col-form-inner col-8 col-md-8 col-lg-8">
                <div class="form-group">
                  <div class="form-label">
                    <label>Endereço<v-tooltip text="Obrigatório. Endereço e telefone do responsável reusam os da empresa." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o endereço"
                      v-model="address"
                    />
                  </div>
                </div>
              </div>



              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Número<v-tooltip text="Obrigatório. A Pagar.me exige street_number." location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Número"
                      v-model="addressNumber"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col">
                <div class="form-group">
                  <div class="form-label">
                    <label>Complemento<v-tooltip text='Se vazio, o Weeduc envia "Sem complemento".' location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Complemento"
                      v-model="addressComplement"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col">
                <div class="form-group">
                  <div class="form-label">
                    <label>Bairro<v-tooltip text="Obrigatório para criar o recebedor Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o bairro"
                      v-model="neighborhood"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col">
                <div class="form-group">
                  <div class="form-label">
                    <label>Cidade<v-tooltip text="Obrigatório para criar o recebedor Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite a cidade"
                      v-model="city"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col">
                <div class="form-group">
                  <div class="form-label">
                    <label>Estado<v-tooltip text="Obrigatório (UF) para criar o recebedor Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o estado"
                      v-model="county"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col">
                <div class="form-group">
                  <div class="form-label">
                    <label>País<v-tooltip text="Só Weeduc — não é enviado à Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o país"
                      v-model="country"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Configurações do Sistema -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <div class="section-title__row">
                    <h4>Configurações do Sistema</h4>
                    <button type="button" class="btnSave btnFillPreview btnFillSection" @click="fillSystemSection">
                      Preencher dados
                    </button>
                  </div>
                  <p>Configurações da plataforma (não vão à Pagar.me).</p>
                </div>
              </div>
              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Tipo de Sistema
                      <v-tooltip :text="fieldTip('typeSystem')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="typeSystem"
                    >
                      <option value="" disabled selected>Selecione o tipo</option>
                      <option value="1">Weeduc</option>
                      <option value="2">Weflix</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3" v-if="String(typeSystem) === '1'">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Tipo de Empresa
                      <v-tooltip :text="fieldTip('typeBusiness')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="typeBusiness"
                    >
                      <option value="" disabled>Selecione o tipo</option>
                      <option value="1">Escolar</option>
                      <option value="2">Corporativo</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Plano de Teste
                      <v-tooltip :text="fieldTip('testPlan')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select class="form-control" v-model.number="testPlan">
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Comentários em Vídeo
                      <v-tooltip :text="fieldTip('videoComments')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select class="form-control" v-model.number="videoComments">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Cor da Empresa
                      <v-tooltip :text="fieldTip('color')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="inputsColors">
                    <input type="color" v-model="color" />
                    <input
                      type="text"
                      class="form-control"
                      v-model="color"
                      placeholder="#ffffff"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Tempo Total de Vídeo
                      <v-tooltip :text="fieldTip('videoTimeTotal')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="videoTimeTotal"
                      placeholder="Tempo total (min)"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Tempo Usado de Vídeo
                      <v-tooltip :text="fieldTip('videoTimeUsed')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="videoTimeUsed"
                      placeholder="Tempo usado (min)"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Restrição de Idade
                      <v-tooltip :text="fieldTip('ageRestricted')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select class="form-control" v-model.number="ageRestricted">
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Token da conta Videoteca
                      <v-tooltip :text="fieldTip('tokenVideoteca')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="tokenVideoteca"
                      placeholder="Token da conta Videoteca (opcional)"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Haverá vendas?
                      <v-tooltip text="Não: dados bancários e split ficam ocultos e não são obrigatórios." location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <select class="form-control" v-model="hasSales" @change="onSalesIntentChange">
                      <option value="" disabled>Selecione</option>
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>
                      Código Recebedor
                      <v-tooltip :text="fieldTip('recipientCode')" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip>
                    </label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="recipientCode"
                      placeholder="Opcional (gerado pela Pagar.me)"
                    />
                  </div>
                </div>
              </div>

<!-- 
            <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Logo</label>
                    <small>Insira uma imagem maior que 250x250 pixels</small>
                  </div>
                  <div class="form-file">
                    <div class="file-wrapper primary">
                      <img
                      :src="logoPreview? logoPreview : logo"
                      alt="Logo"
                      v-show="logoPreview || logo"
                      style="width: 250px;"
                    />
                      <span class="thumbnail">
                        <span class="icon">
                          <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></path>
                            <rect
                              x="1.00049"
                              y="1.40454"
                              width="43.9461"
                              height="36.1909"
                              rx="2.58507"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></rect>
                            <circle
                              cx="14.8948"
                              cy="10.6676"
                              r="3.71629"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></circle>
                          </svg>
                        </span>
                        <span class="text">
                          Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                      </span>
                      <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathLogo"
                        accept=".png, .jpg, .jpeg, .webp"
                      />
                    </div>
                  </div>
                </div>
            </div> -->

            <!-- <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                    <div class="form-label">
                    <label>Favicon</label>
                    <small>Insira uma imagem maior que 250x250 pixels</small>
                    </div>
                    <div class="form-file">
                    <div class="file-wrapper primary">
                        <img
                        :src="faviconPreview? faviconPreview : favicon"
                        alt="Favicon"
                        v-show="faviconPreview || favicon"
                        style="width: 250px;"
                    />
                        <span class="thumbnail">
                        <span class="icon">
                            <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></path>
                            <rect
                                x="1.00049"
                                y="1.40454"
                                width="43.9461"
                                height="36.1909"
                                rx="2.58507"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></rect>
                            <circle
                                cx="14.8948"
                                cy="10.6676"
                                r="3.71629"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></circle>
                            </svg>
                        </span>
                        <span class="text">
                            Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                        </span>
                        <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathFavicon"
                        accept=".png, .jpg, .jpeg, .webp"
                        />
                    </div>
                    </div>
                </div>
                </div> -->


                <!-- <div class="col-form-inner col-4 col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="form-label">
                      <label>Tema<v-tooltip text="Selecione o tema" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <select
                        class="form-control"
                        v-model="theme"
                      >
                        <option value="dark">Dark</option>
                        <option value="light">Light</option>
                      </select>
                      <small class="small">
                          Selecione o tema da interface do sistema.
                      </small>
                    </div>
                  </div>
                </div> -->

                  <!-- Seção: Configurações de Pagamento -->
                  <template v-if="String(hasSales) === '1' && Number(cartStatus) !== 2">
                  <div class="col-form-inner col-12 col-md-12 col-lg-12">
                    <div class="section-title">
                      <h4>Informações de pagamento</h4>
                      <p>Carrinho, antecipação e parcelamento só valem quando há vendas.</p>
                    </div>
                  </div>
                  <div class="col-form-inner col-3 col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="form-label">
                        <label>
                          Status do Carrinho
                          <v-tooltip :text="fieldTip('cartStatus')" location="top">
                            <template v-slot:activator="{ props }">
                              <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                            </template>
                          </v-tooltip>
                        </label>
                      </div>
                      <div class="form-input">
                        <select class="form-control" v-model="cartStatus">
                          <option value="1">Ativo</option>
                          <option value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-form-inner col-3 col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="form-label">
                        <label>
                          Antecipação
                          <v-tooltip :text="fieldTip('anticipation')" location="top">
                            <template v-slot:activator="{ props }">
                              <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                            </template>
                          </v-tooltip>
                        </label>
                      </div>
                      <div class="form-input">
                        <select class="form-control" v-model.number="anticipation">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-form-inner col-3 col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="form-label">
                        <label>
                          Parcelamento no Checkout
                          <v-tooltip :text="fieldTip('intallmentCheckout')" location="top">
                            <template v-slot:activator="{ props }">
                              <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                            </template>
                          </v-tooltip>
                        </label>
                      </div>
                      <div class="form-input">
                        <select class="form-control" v-model.number="intallmentCheckout">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-form-inner col-12 col-md-12 col-lg-12">
                    <div class="section-title">
                      <div class="section-title__row">
                        <h4>Dados Bancários e Split</h4>
                        <button type="button" class="btnSave btnFillPreview btnFillSection" @click="fillBankSection">
                          Preencher dados
                        </button>
                      </div>
                      <p>Dados bancários (recebedor) e split/taxa (compras Weeduc).</p>
                      <p class="sa-field-subtle">
                        A conta deve estar no nome da empresa e no mesmo CNPJ cadastrado — outro CPF/CNPJ é rejeitado pela Pagar.me.
                      </p>
                    </div>
                  </div>
                  <div class="col-form-inner col-3 col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="form-label">
                        <label>Habilitar Split<v-tooltip text="Obrigatório no Weeduc — sem split as compras não passam. Não vai à Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                      </div>
                      <div class="form-input">
                        <select
                          class="form-control"
                          v-model="split"
                          required
                        >
                          <option value="" disabled>Selecione o status</option>
                          <option value="1">Ativo</option>
                          <option value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
              </div>


              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Banco<v-tooltip text="Obrigatório para o recebedor. Depois, só troca conta do mesmo CNPJ." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <select
                      required
                      class="form-control"
                      v-model="bank"
                    >
                      <option value="" disabled selected>Selecione o banco</option>
                      <option value="001">001 - BANCO DO BRASIL S.A.</option>
                      <option value="033">033 - BANCO SANTANDER S.A.</option>
                      <option value="104">104 - CAIXA ECONÔMICA FEDERAL</option>
                      <option value="237">237 - BANCO BRADESCO S.A.</option>
                      <option value="341">341 - BANCO ITAÚ S.A.</option>
                      <option value="077">077 - BANCO INTER S.A.</option>
                      <option value="260">260 - NUBANK</option>
                      <option value="336">336 - BANCO C6 S.A.</option>
                      <option value="290">290 - PAGSEGURO INTERNET S.A.</option>
                      <option value="380">380 - PICPAY</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Agência<v-tooltip text="Obrigatório para o recebedor. Depois, só troca conta do mesmo CNPJ." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="branch"
                      placeholder="Número da agência"
                      v-mask="'####'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Agência<v-tooltip text="Pode ficar vazio — a Pagar.me aceita sem dígito da agência." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      class="form-control"
                      v-model="digitBranch"
                      placeholder="Dígito"
                      v-mask="'#'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Conta<v-tooltip text="Obrigatório para o recebedor. Depois, só troca conta do mesmo CNPJ." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="account"
                      placeholder="Número da conta"
                      v-mask="'#######'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Conta<v-tooltip text="Obrigatório para o recebedor. Depois, só troca conta do mesmo CNPJ." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="digitAccount"
                      placeholder="Dígito"
                      v-mask="'#'"
                    />
                  </div>
                </div>
              </div>

    <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Valor por transação (R$)<v-tooltip text="Obrigatório no Weeduc (taxa) — sem isso as compras não passam. Não vai à Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="transactionValue"
              placeholder="1,00"
            />
          </div>
        </div>
    </div>




    <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Percentual do Cliente (%)<v-tooltip text="Obrigatório no Weeduc para o checkout. Não vai à Pagar.me." location="top"><template v-slot:activator="{ props }"><fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa></template></v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="percentualClient"
              placeholder="10"
            />
          </div>
        </div>
    </div>
                  </template>

    <!-- Seção: Informações do Responsável -->
    <div class="col-form-inner col-12 col-md-12 col-lg-12">
      <div class="section-title">
        <div class="section-title__row">
          <h4>Informações do Responsável</h4>
          <button type="button" class="btnSave btnFillPreview btnFillSection" @click="fillRepresentativeSection">
            Preencher dados
          </button>
        </div>
        <p>Responsável legal do recebedor. Endereço e telefone reusam os da empresa.</p>
      </div>
    </div>
    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Nome do Responsável<v-tooltip text="Obrigatório para o recebedor. Depois de criado, praticamente imutável." location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="nameRepresentative"
              placeholder="João da Silva"
            />
          </div>
        </div>
    </div>


    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>E-mail do Responsável<v-tooltip text="Obrigatório para o recebedor. Depois de criado, praticamente imutável." location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="emailRepresentative"
              placeholder="email@email.com"
            />
          </div>
        </div>
    </div>

      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>CPF do Responsável<v-tooltip text="Obrigatório (11 dígitos). Depois de criado o recebedor, praticamente imutável." location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="idRepresentative"
              v-mask="'###.###.###-##'"
              placeholder="000.000.000-00"
            />
          </div>
        </div>
    </div>



      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Data de Nascimento<v-tooltip text="Obrigatório para o recebedor. Depois de criado, praticamente imutável." location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="date" 
              required
              class="form-control"
              v-model="birthdate"
              placeholder="00/00/0000"
            />
          </div>
        </div>
    </div>



      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Profissão do Responsável<v-tooltip text="Obrigatório para o recebedor. Depois de criado, praticamente imutável." location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="professional_occupation"
              placeholder="Engenheiro"
            />
          </div>
        </div>
    </div>

    <!-- <hr> -->

    <!-- <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>Título<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="title"
                    placeholder="Meu Site"
                />
                <small>Digite o título do seu site.</small>
                </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Tipo do Layout<v-tooltip text="Selecione o estado" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input">
                <select
                class="form-control"
                v-model="typeLayout"
                >
                <option value="" disabled selected>Selecione o tipo</option>
                <option value="1">Clean</option>
                <option value="2">Dark</option>
                </select>
                <small class="small">
                Selecione o tipo de sistema 1 - Weeduc e 2 - Weflix.
                </small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Tipo do Layout Portal<v-tooltip text="Selecione o estado" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input">
                <select
                class="form-control"
                v-model="typeLayoutPortal"
                >
                <option value="" disabled selected>Selecione o tipo</option>
                <option value="1">Clean</option>
                <option value="2">Dark</option>
                </select>
                <small class="small">
                Selecione o tipo de sistema 1 - Weeduc e 2 - Weflix.
                </small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>E-mail<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="emailSite"
                    placeholder="exemplo@dominio.com"
                />
                <small>Digite o e-mail do seu site.</small>
                </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>Telefone<v-tooltip text="Telefone exibido no site" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="phoneSite"
                    placeholder="Digite o telefone"
                    v-mask="'(##) #####-####'"
                />
                <small>Digite o telefone do seu site.</small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
            <div class="form-group">
            <div class="form-label">
                <label>Descrição<v-tooltip text="Campo obrigatório" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input"> 
                <textarea v-model="description"></textarea>
                <small>Nome comercial do seu curso, uso externo.</small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
            <div class="form-group">
            <div class="form-label">
                <label>Palavras Chaves<v-tooltip text="Campo obrigatório" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input"> 
                <textarea v-model="keywords"></textarea>
                <small>Nome comercial do seu curso, uso externo.</small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Banner Principal</label>
                <small>Insira uma imagem maior que 250x250 pixels</small>
            </div>
            <div class="form-file">
                <div class="file-wrapper primary">
                <img
                :src="pathImagePreview? pathImage : logo"
                alt="Logo"
                v-show="pathImage || logo"
                style="width: 250px;"
                />
                <span class="thumbnail">
                    <span class="icon">
                    <svg
                        width="46"
                        height="39"
                        viewBox="0 0 46 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></path>
                        <rect
                        x="1.00049"
                        y="1.40454"
                        width="43.9461"
                        height="36.1909"
                        rx="2.58507"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></rect>
                        <circle
                        cx="14.8948"
                        cy="10.6676"
                        r="3.71629"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></circle>
                    </svg>
                    </span>
                    <span class="text">
                    Clique aqui para selecionar a imagem
                    </span>
                    <LoaderImage :hasReady="loaderImage"/>
                </span>
                <input
                    class="form-control"
                    type="file"
                    @change="updateFilePathLogo"
                    accept=".png, .jpg, .jpeg, .webp"
                />
                </div>
            </div>
            </div>
        </div>
    </div> -->


            </div>
            <div class="actionsSave">
              <button class="btnSave btnCancel" @click="$router.push('/admin/empresas')">
                Voltar
              </button>
              <button class="btnSave" @click="createNewCompany">
                Salvar
              </button>
            </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showCreateConfirmModal" max-width="480" persistent>
      <v-card class="sa-confirm-modal">
        <v-card-title class="sa-confirm-modal__title">
          Confirma a criação?
        </v-card-title>
        <v-card-text class="sa-confirm-modal__body">
          <p>
            Após o recebedor ser criado na Pagar.me, CNPJ, razão social, e-mail,
            telefone, endereço e dados do responsável quase não podem ser alterados.
          </p>
          <p>
            Conta bancária só muda depois se for do <strong>mesmo CNPJ</strong>.
          </p>
          <p class="mb-0">
            Para outro CNPJ será necessário cadastrar outra empresa.
          </p>
        </v-card-text>
        <v-card-actions class="sa-confirm-modal__actions">
          <v-btn
            class="flex-grow-1"
            variant="tonal"
            color="grey-darken-3"
            :disabled="!hasReady"
            @click="cancelCreateConfirm"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="flex-grow-1 text-white"
            variant="flat"
            color="primary"
            :loading="!hasReady"
            :disabled="!hasReady"
            @click="confirmCreateCompany"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Loader :hasReady="hasReady"/>
  </SuperAdminShell>
</template>

<script>
  import SuperAdminShell from '@/Views/Weflix/SuperAdminShell.vue'
  import { mapState, mapActions } from 'vuex';
  import ApiCep from '@/utils/cep.js';
  import superAdmin from '@/utils/superAdmin';
  import { applySuperAdminBranding } from '@/utils/superAdmin/branding';
  import { validateCompanyForm, fieldTip } from '@/utils/superAdmin/companyFormRules';
  import Loader from '@/components/Weflix/Loader.vue';
  import { toast } from 'vue3-toastify';


  export default {
    data() {
      return {
        tradeName: '',
        bank: '',
        branch: '',
        digitBranch: '',
        account: '',
        split: '',
        loaderImage: false,
        idFiscal: '',
        county: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        city: '',
        neighborhood: '',
        state: '',
        name: '',
        postcode: '',
        imagePath: '',
        branch: '',
        digitBranch: '',
        account: '',
        videoTimeTotal: 1000,
        videoTimeUsed: 0,
        ageRestricted: 0,
        tokenVideoteca: '',
        recipientCode: '',
        anticipation: 1,
        videoComments: 1,
        intallmentCheckout: 1,
        corporateCompany: false,
        isCorporate: false,
        email: '',
        phone: '',
        percentualClient: '',
        transactionValue: '',
        url: '',
        url1: '',
        url2: '',
        typeSystem: 1,
        typeBusiness: 1,
        testPlan: 1,
        cartStatus: 1,
        hasSales: '',
        color: '#00FF00',
        country: 'Brasil',
        emailRepresentative: '',
        nameRepresentative: '',
        professional_occupation: '',
        birthdate: '',
        idRepresentative: '',
        title: '',
        emailSite: '',
        phoneSite: '',
        typeLayout: 0,
        urlTemporary: '',
        hasValidDomain: null,
        hasReady: true,
        digitAccount: '',
        showCreateConfirmModal: false,
      }
    },
    components: {
      SuperAdminShell,
      Loader
    },
    computed: {
      ...mapState(['token']),
    },
    methods: {
        ...mapActions(['storeCurrentCompanyCreated']),
      fieldTip,
      fillCompanySection() {
        const stamp = Date.now();
        this.tradeName = 'Empresa LTDA';
        this.name = 'Recebedor pessoa juridica';
        this.idFiscal = '77699131000133';
        this.email = `empresax+${stamp}@avengers.com`;
        this.phone = '(21) 99464-7568';
      },
      async fillAddressSection() {
        this.skipCepLookup = true;
        this.postcode = '20021-130';
        this.addressNumber = '375';
        this.addressComplement = 'Bloco A';
        this.country = 'Brasil';
        try {
          const response = await ApiCep.getDataCep('20021130');
          if (response && !response.erro) {
            this.address = response.logradouro || 'Av. General Justo';
            this.neighborhood = response.bairro || 'Centro';
            this.city = response.localidade || 'Rio de Janeiro';
            this.county = response.uf || 'RJ';
          } else {
            this.applyAddressFallback();
          }
        } catch (error) {
          this.applyAddressFallback();
        }
        this.addressNumber = '375';
        this.addressComplement = 'Bloco A';
        this.country = 'Brasil';
        this.$nextTick(() => {
          this.postcode = '20021-130';
          this.addressNumber = '375';
          this.addressComplement = 'Bloco A';
          this.skipCepLookup = false;
        });
      },
      applyAddressFallback() {
        this.address = 'Av. General Justo';
        this.neighborhood = 'Centro';
        this.city = 'Rio de Janeiro';
        this.county = 'RJ';
      },
      fillSystemSection() {
        this.typeSystem = 1;
        this.typeBusiness = 1;
        this.testPlan = 1;
        this.hasSales = '1';
        this.color = '#250891';
        this.videoTimeTotal = 1000;
        this.videoTimeUsed = 0;
        this.ageRestricted = 0;
        this.videoComments = 1;
        this.corporateCompany = false;
        this.isCorporate = false;
        this.tokenVideoteca = '';
        this.recipientCode = '';
        this.imagePath = '';
      },
      onSalesIntentChange() {
        if (String(this.hasSales) === '1') {
          if (Number(this.cartStatus) === 2) this.cartStatus = 1;
          return;
        }
        if (String(this.hasSales) === '0') {
          this.split = '';
          this.bank = '';
          this.branch = '';
          this.digitBranch = '';
          this.account = '';
          this.digitAccount = '';
          this.transactionValue = '';
          this.percentualClient = '';
          this.cartStatus = 2;
          this.anticipation = 0;
          this.intallmentCheckout = 0;
        }
      },
      fillBankSection() {
        this.split = 1;
        this.bank = '341';
        this.branch = '1234';
        this.digitBranch = '6';
        this.account = '12345';
        this.digitAccount = '6';
        this.transactionValue = '1,50';
        this.percentualClient = '10';
        this.cartStatus = 1;
        this.anticipation = 1;
        this.intallmentCheckout = 1;
      },
      fillRepresentativeSection() {
        const stamp = Date.now();
        this.nameRepresentative = 'Tony Stark';
        this.emailRepresentative = `tstark+${stamp}@avengers.com`;
        this.idRepresentative = '26224451990';
        this.birthdate = '1984-10-30';
        this.professional_occupation = 'Vendedor';
      },
      fillPreviewData() {
        this.fillCompanySection();
        this.fillAddressSection();
        this.fillSystemSection();
        this.fillBankSection();
        this.fillRepresentativeSection();
      },
      async createNewCompany() {
        const phoneDigits = String(this.phone || '').replace(/[^\d]/g, '');
        const addressNumber = String(this.addressNumber || '').trim();

        if (this.hasSales !== '0' && this.hasSales !== '1') {
          toast.error('Informe se a empresa terá vendas.');
          return;
        }

        const validation = validateCompanyForm({
          tradeName: this.tradeName,
          name: this.name,
          idFiscal: this.idFiscal,
          email: this.email,
          phone: this.phone,
          postcode: this.postcode,
          address: this.address,
          addressNumber,
          neighborhood: this.neighborhood,
          city: this.city,
          county: this.county,
          bank: this.bank,
          branch: this.branch,
          account: this.account,
          digitAccount: this.digitAccount,
          nameRepresentative: this.nameRepresentative,
          emailRepresentative: this.emailRepresentative,
          documentRepresentative: this.idRepresentative,
          birthdateRepresentative: this.birthdate,
          occupationRepresentative: this.professional_occupation,
          split: this.split,
          percentualClient: this.percentualClient,
          transactionValue: this.transactionValue,
          hasSales: this.hasSales,
        });

        if (!validation.ok) {
          toast.error(
            `Para criar a empresa (recebedor + compras Weeduc), complete:\n• ${validation.errors.join('\n• ')}`,
          );
          return;
        }

        this.showCreateConfirmModal = true;
      },
      cancelCreateConfirm() {
        this.showCreateConfirmModal = false;
      },
      async confirmCreateCompany() {
        this.showCreateConfirmModal = false;
        await this.submitCreateCompany();
      },
      async submitCreateCompany() {
        this.hasReady = false;
        const phoneDigits = String(this.phone || '').replace(/[^\d]/g, '');
        const addressNumber = String(this.addressNumber || '').trim();
        const addressComplement = String(this.addressComplement || '').trim() || 'Sem complemento';
        const willSell = String(this.hasSales) === '1';
        const isWeeducCorporate = String(this.typeSystem) === '1' && String(this.typeBusiness) === '2';
        const percentualClient = willSell
          ? Number(String(this.percentualClient).replace(',', '.'))
          : null;
        const transactionValue = willSell
          ? Number(String(this.transactionValue).replace(',', '.'))
          : null;

        const payload ={
        "company": {
            "idFiscal": this.idFiscal.replace(/[^\d]/g, ''),
            "name": this.name,
            "country": this.country || 'Brasil',
            "county": this.county,
            "city": this.city,
            "address": this.address,
            "addressNumber": addressNumber,
            "addressComplement": addressComplement,
            "postcode": this.postcode.replace(/[^\d]/g, ''),
            "testPlan": Number(this.testPlan) || 0,
            "typeSystem": Number(this.typeSystem) || 1,
            ...(String(this.typeSystem) === '1'
              ? { typeBusiness: Number(this.typeBusiness) || 1 }
              : {}),
            "anticipation": willSell ? (Number(this.anticipation) || 0) : 0,
            "videoComments": Number(this.videoComments) || 0,
            "cartStatus": willSell ? (Number(this.cartStatus) || 0) : 2,
            "intallmentCheckout": willSell ? (Number(this.intallmentCheckout) || 0) : 0,
            "color": this.color || null,
            "imagePath": this.imagePath || '',
            "imageFinalPath": this.imagePath || '',
            "bank": willSell ? this.bank : null,
            "branch": willSell ? this.branch : null,
            "digitBranch": willSell ? this.digitBranch : null,
            "account": willSell ? this.account : null,
            "digitAccount": willSell ? this.digitAccount : null,
            "videoTimeTotal": Number(this.videoTimeTotal) || 0,
            "videoTimeUsed": Number(this.videoTimeUsed) || 0,
            "tokenVideoteca": (this.tokenVideoteca || '').trim() || null,
            "ageRestricted": Number(this.ageRestricted) || 0,
            "tradeName": this.tradeName,
            "email": this.email,
            "phone": phoneDigits,
            "percentualClient": percentualClient,
            "transactionValue": transactionValue,
            "recipientCode": (this.recipientCode || '').trim() || null,
            "neighborhood": this.neighborhood,
            "split": willSell ? (this.split == "1" || this.split === 1 ? 1 : 0) : null,
            "corporateCompany": isWeeducCorporate,
            "isCorporate": isWeeducCorporate,
        },
        "representative": {
            "name": this.nameRepresentative,
            "email": this.emailRepresentative,
            "document": this.idRepresentative.replace(/[^\d]/g, ''),
            "birthdate": this.birthdate,
            "professional_occupation": this.professional_occupation
        }
        }
        console.debug(payload);
        try {
          const response = await superAdmin.createCompany(this.token, payload);
          this.hasReady = true;
          this.storeCurrentCompanyCreated({currentCompanyCreated: response});
          if (response?.pagarmeError) {
            toast.warning(
              `Empresa criada, mas o recebedor Pagar.me falhou: ${response.pagarmeError}`,
              { autoClose: 8000 },
            );
          }
          const companyId = response?.company?.id ?? response?.id;
          if (!companyId) {
            toast.error('Empresa criada, mas não foi possível abrir a edição.');
            return;
          }
          try {
            sessionStorage.setItem('saEditTab', 'layout');
          } catch (_) { /* ignore */ }
          this.$router.push({
            name: 'CompanySuperAdmin',
            params: { slug: String(companyId) },
            query: { tab: 'layout' },
          });
        } catch (error) {
          console.error(error);
          console.error('1step status:', error?.response?.status);
          console.error('1step response:', error?.response?.data);
          this.hasReady = true;
          const data = error?.response?.data;
          const message = (typeof data === 'string' ? data : null)
            || data?.message
            || data?.error
            || error?.message
            || 'Erro ao cadastrar empresa no Pagar.me.';
          toast.error(message);
        }
      },
    setPageTitle() {
      applySuperAdminBranding();
    },
    setFavicon() {
      applySuperAdminBranding();
    },
    async getCep(){
        if(this.postcode.length >= 7){
            try {
                const response = await ApiCep.getDataCep(this.postcode);
                this.county = response.uf;
                this.address = response.logradouro;
                // ViaCEP não retorna número; não apagar o valor já preenchido
                if (response.numero) {
                  this.addressNumber = response.numero;
                }
                if (response.complemento) {
                  this.addressComplement = response.complemento;
                }
                this.city = response.localidade;
                this.neighborhood = response.bairro;
            } catch (error) {
              
            }
        }
    },

    },
    mounted() {
      this.setPageTitle();
      this.setFavicon();
    }
  }
</script>

<style scoped>
.sa-field-notice {
  margin: 0 0 1.25rem;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  border: 1px solid #dbe3f0;
  background: #f4f7fb;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #334155;
}
.sa-field-notice strong {
  display: block;
  margin-bottom: 0.35rem;
}
.sa-field-notice p {
  margin: 0;
}
.sa-field-notice--info {
  border-color: #bfdbfe;
  background: #eff6ff;
}
.sa-field-notice--warn {
  border-color: #fcd34d;
  background: #fffbeb;
}
.sa-field-tag {
  display: inline-block;
  margin-left: 0.35rem;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  vertical-align: middle;
}
.sa-field-tag--req {
  background: #fee2e2;
  color: #b91c1c;
}
.sa-field-tag--opt {
  background: #e0e7ff;
  color: #3730a3;
}
.sa-field-tag--weeduc {
  background: #f3f4f6;
  color: #4b5563;
}
.sa-field-hint {
  display: block;
  margin-top: 0.3rem;
  font-size: 0.75rem;
  color: #6b7280;
}

.section-title__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}
.section-title__row h4 {
  margin: 0;
}
.super-admin-page .btnFillSection {
  min-width: 0;
  padding: 6px 12px;
  font-size: 0.8125rem;
  line-height: 1.2;
  box-shadow: none;
}
.section-title .sa-field-subtle {
  margin: 0.5rem 0 0;
  font-size: 0.8125rem;
  color: #697386;
  line-height: 1.4;
  text-align: left;
  width: 100%;
}
.sa-field-subtle :deep(svg) {
  width: 0.75rem;
  height: 0.75rem;
  margin: 0 0.15rem;
  vertical-align: -0.05rem;
  opacity: 0.7;
}
.sa-confirm-modal {
  border-radius: 12px;
  overflow: hidden;
}
.sa-confirm-modal__title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  padding-bottom: 0.25rem;
}
.sa-confirm-modal__body {
  color: #4b5563;
  font-size: 0.9375rem;
  line-height: 1.5;
}
.sa-confirm-modal__body p {
  margin: 0 0 0.75rem;
}
.sa-confirm-modal__actions {
  padding: 0 1rem 1rem;
  gap: 0.75rem;
}
</style>
